import { ReactNode } from "react";
import { classNames } from "primereact/utils";
import { BreadCrumb } from "primereact/breadcrumb";
import { useLocation } from "react-router-dom";

import "../../styles/layout.scss";
import AppToolBar from "./toolbar";
import { REILogo as Logo } from "../../images";
import Elevio from "elevio/lib/react";
import { WindowElev } from "elevio/lib/elevio";
import { ELEVIO_ID } from "../../utils/constants";
import Footer from "./footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const showSideMenu = false;

  const containerClass = classNames("layout-wrapper", "layout-static", {
    "layout-static-inactive": !showSideMenu,
    "layout-mobile-active": showSideMenu,
  });

  const breadcrumbMap: Record<string, { label: string; parent?: string }> = {
    dashboard: { label: "Dashboard" },
    myaccount: { label: "" },
    "rp-data-pricefinder": { label: "RP Data Pricefinder" },
    "property-analyser": { label: "Property Analyser" },
    "analyse-property": {
      label: "Analyse Property",
      parent: "property-analyser",
    },
    archistar: { label: "Archistar" },
    "investment-calculators": { label: "Investment Calculators" },
    "suburb-reports": { label: "Suburb Reports" },
    depreciation: { label: "Depreciation" },
    "property-analyser/analysis-report": {
      label: "Analyse Report",
      parent: "property-analyser",
    },
    "portfolio-tracker": { label: "Portfolio Tracker" },
    "": { label: "Investar Search" },
  };

  const currentPath = location.pathname.replace("/", "");
  const breadcrumbItems = [];

  if (breadcrumbMap[currentPath]) {
    const { label, parent } = breadcrumbMap[currentPath];
    if (parent) {
      breadcrumbItems.push({ label: breadcrumbMap[parent].label, url: `/${parent}` });
    }

    if (label === "Investar Search") {
      breadcrumbItems.push({
        label,
        command: () => {
          window.location.reload();
        },
      });
    } else {
      breadcrumbItems.push({ label });
    }
  } else {
    breadcrumbItems.push({
      label: "Investar Search",
      command: () => {
        window.location.reload();
      },
    });
  }

  return (
    <div className={containerClass}>
      <AppToolBar />

      <div className="layout-main-container">
        {currentPath != "myaccount" && (
          <BreadCrumb
            model={breadcrumbItems}
            className="bg-transparent border-none"
            home={{
              icon: "pi pi-home",
              command: () => {
                if (currentPath === "") {
                  window.location.reload();
                }
              },
            }}
          />
        )}
        <div className="layout-main">{children}</div>
      </div>
      <Footer />
      {ELEVIO_ID && (
        <Elevio
          accountId={ELEVIO_ID}
          onLoad={(apiInstance: WindowElev) => {
            apiInstance?.hideModules?.([1]);
          }}
        />
      )}
    </div>
  );
};

export default Layout;
